// src/components/common/Badge.jsx
import React from 'react';

const getColorClass = (type) => {
  switch (type?.toLowerCase()) {
    case 'high':
    case 'critical':
    case 'error':
      return 'bg-red-100 text-red-800';
    case 'medium':
    case 'warning':
      return 'bg-yellow-100 text-yellow-800';
    case 'low':
    case 'informational':
    case 'info':
      return 'bg-blue-100 text-blue-800';
    case 'success':
    case 'resolved':
      return 'bg-green-100 text-green-800';
    case 'online':
      return 'bg-green-100 text-green-800';
    case 'offline':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const Badge = ({ type, text }) => {
  const displayText = text || type;
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getColorClass(type)}`}>
      {displayText}
    </span>
  );
};

// ✅ Add this line
export default Badge;
